import type { ReactNode } from 'react';

import { Tooltip, TooltipContent, TooltipTrigger } from '~/components/ui/tooltip';

/**
 * Explains why a control is disabled. Disabled buttons swallow pointer events, so the
 * tooltip hangs off a focusable wrapper; with no `reason` the child renders untouched.
 */
export function DisabledReason({
  reason,
  children,
}: {
  reason: string | null;
  children: ReactNode;
}) {
  if (!reason) return <>{children}</>;
  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- lets keyboard users reach the explanation of a disabled button */}
        <span tabIndex={0} className="inline-flex cursor-not-allowed" aria-label={reason}>
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent>{reason}</TooltipContent>
    </Tooltip>
  );
}
